import React from "react";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

interface OrderTipLineProps {
    tab: OrderTab;
}

const OrderTipLine: React.FC<OrderTipLineProps> = ({ tab }) => {
    if (![OrderTab.CANCELED, OrderTab.ABNORMAL, OrderTab.LOGISTICS_WARNING, OrderTab.SUCCESS].includes(tab)) {
        return null;
    }

    let text: React.ReactNode = "";

    switch (tab) {
        case OrderTab.CANCELED:
            text = "已取消订单在'发货易'中只保留3个月（下单时间）";
            break;
        case OrderTab.ABNORMAL:
            text = (
                <span>
                    请尽快人工审核异常订单，确认不会影响发货后删除异常即可！注：异常订单超过14天不处理该订单将自动解除异常提醒。
                    <a
                        href="https://qw15p3s8hv.feishu.cn/wiki/wikcn0yXII76fUNJCJuk29DKVgg?from=from_copylink"
                        target="_blank"
                    >
                        查看异常订单生成规则
                    </a>
                </span>
            );
            break;
        case OrderTab.LOGISTICS_WARNING:
            text = (
                <span>
                    物流异常预警目前仅支持已发货订单，仅支持快递：圆通、中通、申通、百世、韵达、安能、京东快递、顺丰、天天、德邦、跨越、众邮、极兔，如有物流预警不准确请联系客服！
                    <Link to="/setting/orderLogisticsWarning">设置物流异常预警</Link>
                </span>
            );

            break;
        case OrderTab.SUCCESS:
            text = "已完成订单在'发货易'中只保留3个月（下单时间）";
            break;
        default:
            break;
    }

    return (
        <p className="mb10" style={{ color: "#8a6d3b" }}>
            <InfoCircleOutlined className="mr10" />

            {text}
        </p>
    );
};

export default React.memo(OrderTipLine);
